import React, { useMemo, useRef } from 'react';
import {
  Autocomplete,
  Box,
  CircularProgress,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from '@mui/material';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Get_All_Sales_Action,
  Get_All_Sales_By_TeamLeader_Email_Action,
} from '../Redux/Actions/SalesAction';
import SendIcon from '@mui/icons-material/Send';
import {
  AssignleadsinteamleaderAction,
  GetOneClientAction,
  UpdateClientAction,
} from '../Redux/Actions/UsersAction';
import { Notify } from '../Utility/Notify';
import { Link, useParams } from 'react-router-dom';
import Container from 'react-bootstrap/esm/Container';
import { Col, Row } from 'react-bootstrap';
import {
  Get_All_Lead_Assigned_Data_Action,
  Insert_Lead_Assigned_Data_Action,
} from '../Redux/Actions/Lead_Assigned_Action';
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
import { useTheme } from '@mui/material/styles';
import axios from 'axios';
import { db_url } from '../Api/BaseUrl';
import { GetAll_stage_Data } from '../Redux/Actions/Stage_Action';

const chunkArray = (array, size) => {
  const chunked = [];
  for (let i = 0; i < array.length; i += size) {
    chunked.push(array.slice(i, i + size));
  }
  return chunked;
};
export const TeamLeaderAssignLeadToSalesPage = () => {
  const theme = useTheme();
  const mode = theme.palette.mode; // جلب الوضع الحالي (dark / li
  const [userlogin, setuserlogin] = useState('');
  const [clearHistory, setClearHistory] = useState(false);
  const [selectedOption, setSelectedOption] = useState('option1');
  const [selectedStage, setSelectedStage] = useState(null);

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem('user'));
    if (user) {
      setuserlogin(user);
    }
  }, []);

  const { id } = useParams();
  const dispatch = useDispatch();
  const [loading, setloading] = React.useState(true);
  const [sendloading, setsendloading] = React.useState(false);

  //add state to sales
  const [salesname, setsalesname] = useState('');
  const [selectedSalesDataArray, setSelectedSalesDataArray] = useState([]);

  const resStagesData = useSelector((state) => state.Allstages.stage?.data || []);

  // 🩵 نعمل نسخة محلية تحافظ على الداتا حتى لو الـ Redux اتفضى
  const [localStages, setLocalStages] = useState([]);

  useEffect(() => {
    // لو وصلت بيانات جديدة مش فاضية نحفظها محليًا
    if (Array.isArray(resStagesData) && resStagesData.length > 0) {
      setLocalStages(resStagesData);
    }
  }, [resStagesData]);
  //change state
  //   const onsaleschange = (e) => {
  //   const selectedId = e.target.value;
  //   setsalesname(selectedId);

  //   const selectedSales = salsedata.find(sales => sales._id === selectedId);
  //   if (selectedSales) {
  //     // استبدل المصفوفة كاملة بالقيمة الجديدة فقط
  //     setSelectedSalesDataArray([selectedSales]);
  //   } else {
  //     // لو مش لاقي حاجة فاضية
  //     setSelectedSalesDataArray([]);
  //   }
  // };

  const userEmail = useMemo(() => {
    return userlogin?.data?.email || null;
  }, [userlogin]);

  console.log(resStagesData, 'resStagesData');
  const getdatasales = async () => {
    if (userEmail) {
      await dispatch(Get_All_Sales_By_TeamLeader_Email_Action(userEmail));
    }
    await dispatch(GetOneClientAction(id));
  };
  //get sales data
  //=============================================

  useEffect(() => {
    if (userEmail) {
      getdatasales(userEmail);
      dispatch(GetAll_stage_Data());
    }
  }, [userEmail]);

  const resSalesData = useSelector((state) => state.AllSales.salesforteamleaders);

  let salsedata = [];

  if (resSalesData && resSalesData.data) {
    salsedata = resSalesData.data;
  } else {
    salsedata = [];
  }

  const onsaleschange = (event, selectedOption) => {
    setsalesname(event.target.value);
    setSelectedSalesDataArray([selectedOption]);
    console.log(event.target.value, '444');
  };

  const user = JSON.parse(localStorage.getItem('user'));

  const storedLeads = localStorage.getItem('selectedleedsbyteamleader');

  const leadsall = storedLeads ? JSON.parse(storedLeads) : [];

  const stagechange = (event, newValue) => {
    setSelectedStage(newValue);
    // console.log(newValue.value);
  };

  // console.log(leadsall,"leadsall")
  // console.log(id)
  const senddleedtosalesaction = async (e) => {
    e.preventDefault();
    if (salesname === '') {
      Notify('error', 'Please select sales', 'error');
      return;
    } else {
      setloading(true);
      setsendloading(true);

      // const updatePromises = leadsall.map(leadId =>
      //   dispatch(AssignleadsinteamleaderAction(leadId,userlogin?.data?._id,salesname))
      // );

      const updateDataTemplate = {
        sales: salesname,
      };
      // ✅ لو المستخدم اختار Change Stage (option2)، أضف الـ stage من الـ Autocomplete
      if (selectedOption === 'option2' && selectedStage?.value) {
        updateDataTemplate.stage = selectedStage.value;
      }
      const leadChunks = chunkArray(leadsall, 10);

      for (const chunk of leadChunks) {
        await Promise.all(
          chunk.map(
            async (leadId) =>
              await dispatch(
                AssignleadsinteamleaderAction(
                  leadId,
                  userlogin?.data?._id,
                  salesname,
                  clearHistory,
                  updateDataTemplate.stage,
                ),
              ),
          ),
        );
      }

      //          const response =  axios.post("http://localhost:8000/api/v1/Notification/send-fcm", {
      //   // fcmToken: "dxQwqbs7Z3FrdeBOb1Epb_:APA91bE_3tXhTuYhMBOb1c1LMbPK9hk1Omb0tGLGko8W54sKcazmaFs28ZBVRfGbOlq73jBPsCCGCIlL7pehxcg45hrdV5zikPQHo90qvw1s8S-2MJnHGQ8",
      //       fcmToken: selectedSalesDataArray[0]?.userlog?.fcmToken,
      //   title: "💬 New Assign Lead (FCM)",
      // body: `    New Assign Lead From User : ${userlogin?.data?.name}  And Assigned To User Name : ${selectedSalesDataArray[0]?.name}`,
      // }, {
      //   headers: {
      //     "Content-Type": "application/json"
      //   }
      // });
      // console.log("✅ Notification response:", response.data);

      // إرسال إشعارات منفصلة لكل Lead
      //     for (const leadId of leadsall) {
      //       // هنا تقدر تجيب بيانات lead بناءً على id لو عندك، أو تستخدم الاسم الموجود عندك
      // //       const leadName = leeddata.find(lead => lead._id === leadId)?.name || "Lead";
      // // console.log(leeddata,"ss")
      //       // تبعت Notification لكل Lead باسمه
      //       const response = await axios.post("http://localhost:8000/api/v1/Notification/send-fcm", {
      //         fcmToken: selectedSalesDataArray[0]?.userlog?.fcmToken,
      //         title: "💬 New Assign Lead (FCM)",
      //         body: `New Assign Lead From User: ${userlogin?.data?.name} Assigned New Lead For You: ***** (${leadsall.length})`,
      //       }, {
      //         headers: { "Content-Type": "application/json" }
      //       });

      //       console.log(`✅ Notification response for lead:`, response.data);
      //     }

      // const notificationPromises = leadsall.map((leadId, index) => {
      //   const leadName = leeddata.find(lead => lead._id === leadId)?.name || "Lead";

      //   // return axios.post("https://apirender8.onrender.com/api/v1/Notification/send-fcm", {
      //     return axios.post(`${db_url}api/v1/Notification/send-fcm`, {

      //     fcmToken: selectedSalesDataArray[0]?.userlog?.fcmToken,
      //     title: "💬 New Assign Lead (FCM)",
      //     body: `New Assign Lead From User: ${userlogin?.data?.name} | Assigned Lead ${leadName} (${index + 1}) For You`,
      //   }, {
      //     headers: {
      //       "Content-Type": "application/json"
      //     }
      //   })
      //   .then(response => {
      //     // console.log(`✅ Notification ${index + 1} response:`, response.data);
      //   })
      //   .catch(error => {
      //     console.error(`❌ Failed to send notification ${index + 1}:`, error);
      //   });
      // });

      // await Promise.all(notificationPromises);

      // await Promise.all(updatePromises);

      //           //تسجيل كل هذه الداتا
      //           // LeadAssigned
      //          // تسجيل كل Lead بشكل منفصل في الجدول الخاص بها
      //          const insertPromises = leadsall.map((leadId) =>
      //           dispatch(
      //             Insert_Lead_Assigned_Data_Action({
      //               LeadId: leadId, // تسجيل الـ LeadId الفردي
      //               date_Assigned: new Date().toISOString().split('T')[0], // التاريخ الحالي
      //               Assigned_From: user.data._id, // المستخدم الذي قام بالإسناد
      //               Assigned_to: salesname, // اسم الـ sales
      //             clearHistory: clearHistory, // ✅ أضف هذا السطر
      //     })
      //   ).catch(error => {
      //   Notify('error', `Failed to insert lead ${leadId}`, 'error');
      //     throw error; // لإيقاف العملية إذا أردت
      //   })
      // );

      //         // انتظار انتهاء جميع عمليات الإدخال
      //         await Promise.all(insertPromises);

      setloading(false);
      setsendloading(false);
    }
  };

  const resleeddata = useSelector((state) => state.Allusers.Assignleadesinteamleader);

  useEffect(() => {
    if (loading === false) {
      // console.log(resleeddata,"sasasa")
      if (resleeddata && resleeddata?.status === 200) {
        Notify('success', 'Successfully updated', 'success');
        // setTimeout(() => { window.location.href='#/LeadsForTeamLeaders' }, 1500)
      } else {
        Notify('error', 'Failed to update', 'error');
      }
    }
  }, [loading]);

  let leeddata = [];
  if (resleeddata && resleeddata.data) {
    leeddata = resleeddata.data;
  } else {
    leeddata = [];
  }
  //get one leed
  //======================================
  const [isLoading, setIsLoading] = useState(true); // حالة التحميل

  // get all Assigned data by leads
  //========================================
  // استخدم useRef لتخزين قيمة leadsall السابقة
  const [assignedLeadsData, setAssignedLeadsData] = useState([]); // تخزين البيانات المسترجعة

  // تخزين القيمة السابقة لمنع إعادة التحديث غير الضرورية
  const prevLeadsallRef = useRef([]);

  useEffect(() => {
    const fetchData = async () => {
      if (
        leadsall.length === 0 ||
        JSON.stringify(leadsall) === JSON.stringify(prevLeadsallRef.current) // مقارنة القيم القديمة بالجديدة
      ) {
        return; // لا تقم بإعادة التحميل إذا لم تتغير البيانات
      }

      setIsLoading(true);
      prevLeadsallRef.current = leadsall; // تحديث القيمة السابقة

      try {
        // إرسال جميع الطلبات واستقبال النتائج
        const responses = await Promise.all(
          leadsall.map(async (id) => {
            const result = await dispatch(Get_All_Lead_Assigned_Data_Action(id));
            return { id, data: result }; // تخزين كل `leadId` مع بياناته
          }),
        );

        setAssignedLeadsData(responses); // تحديث البيانات المسترجعة
      } catch (error) {
        console.error('Error loading assigned leads:', error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, [leadsall, dispatch]);

  const resAssignedData = useSelector((state) => state.AllLead_Assigned.Lead_Assigned);

  let resAllassignedLeadArray = Array.isArray(resAssignedData?.data) ? resAssignedData.data : [];

  return (
    <Container className="startpage">
      <Row>
        <Col sm={2}></Col>
        <Col sm={10}>
          {/* <SendLeedTOSalesModel user={user}/> */}
          {/* <a style={{textDecoration:'none'}} href='/client' className='d-flex'><div style={{color:'#0F7687',fontWeight:'bold'}}>Send Leed</div><KeyboardDoubleArrowRightIcon/> Go Back </a> */}
          <Link to={`/AllLeadsForTeamLeader`} style={{ textDecoration: 'none', color: '#102dff' }}>
            <span style={{ fontWeight: 'bold' }}>Home</span>
          </Link>{' '}
          <KeyboardDoubleArrowRightIcon /> <span style={{ color: '#666' }}>Send Lead</span>
          <Box>
            <Typography
              id="modal-modal-title"
              variant="h6"
              component="h2"
              style={{ color: '#666' }}
            >
              Choose Sales To Send a `Leed` For Him {`--->>`}{' '}
              <span style={{ color: 'royalblue', fontWeight: 'bold' }}>{leeddata.name} </span>{' '}
              `(Leed)` .
            </Typography>

            <Typography id="modal-modal-description" sx={{ mt: 2 }}>
              {/* <FormControl onChange={onsaleschange} fullWidth   style={{marginTop:'10px',color: mode === "dark" ? "#90caf9" : "#0F7687",backgroundColor: mode === "dark" ? "#252525" : "#f5f5f5"}}          > 
        <InputLabel id="select-label-Sales" >Choose Sales</InputLabel>
                <Select
                  labelId="select-label-Sales"
                  id="select1"
                   value={salesname}
                   onChange={onsaleschange}
                  label="Choose Sales"
                > 
                  { salsedata && salsedata.length > 0 ? (
            salsedata.map((sales) => {
                const isAssigned = resAllassignedLeadArray.some(item => item.Assigned_to?(item.Assigned_to._id=== sales._id):null );
                
                return (
                    <MenuItem
                        key={sales._id}
                        value={sales._id}
                        style={{
                            background:leadsall.length<=1?( isAssigned ? "#0F7876" : "white"):null,
                            border: "2px solid white",
                            color:'black'
                        }}
                        
                    >
                        {sales.name}
                    </MenuItem>
                );
            })
        ) : null }
                       
        
                       </Select>
        
               </FormControl>           */}

              <FormControl
                onChange={onsaleschange}
                fullWidth
                style={{
                  marginTop: '10px',
                  color: mode === 'dark' ? '#90caf9' : '#666',
                  backgroundColor: mode === 'dark' ? '#252525' : '#f5f5f5',
                }}
              >
                <InputLabel id="select-label-Sales">Choose Sales</InputLabel>
                <Select
                  labelId="select-label-Sales"
                  id="select1"
                  value={salesname}
                  onChange={onsaleschange}
                  label="Choose Sales"
                >
                  {salsedata && salsedata.length > 0
                    ? salsedata
                        .filter((sales) => sales?.userlog?.name !== userlogin?.data?.name) // ✅ هنا الشرط
                        .map((sales) => {
                          const isAssigned = resAllassignedLeadArray.some((item) =>
                            item.Assigned_to ? item.Assigned_to._id === sales._id : null,
                          );

                          return (
                            <MenuItem
                              key={sales._id}
                              value={sales._id}
                              style={{
                                background:
                                  leadsall.length <= 1 ? (isAssigned ? '#666' : 'white') : null,
                                border: '2px solid white',
                                color: 'black',
                              }}
                            >
                              {sales.name}
                            </MenuItem>
                          );
                        })
                    : null}
                </Select>
              </FormControl>

              {/* <Box sx={{ mt: 2 }}>
  <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>Selected Sales Data:</Typography>
  {selectedSalesDataArray.length > 0 ? (
    selectedSalesDataArray.map((sales, idx) => (
      <Box key={idx} sx={{ ml: 2 }}>
        <Typography sx={{ fontSize: '14px' }}>• Name: {sales.name}</Typography>
        <Typography sx={{ fontSize: '14px' }}>• Email: {sales.userlog?.email || "N/A"}</Typography>
        <Typography sx={{ fontSize: '14px' }}>• Phone: {sales.userlog?.phone || "N/A"}</Typography>
        <Typography sx={{ fontSize: '14px' }}>• Role: {sales.userlog?.role || "N/A"}</Typography>
      </Box>
    ))
  ) : (
    <Typography sx={{ fontSize: '14px', color: '#888' }}>No sales selected yet.</Typography>
  )}
</Box> */}

              <Box display="flex" alignItems="center" mt={2} sx={{ gap: '10px' }}>
                <label
                  htmlFor="clear-history"
                  style={{
                    position: 'relative',
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  <input
                    type="checkbox"
                    id="clear-history"
                    checked={clearHistory}
                    onChange={(e) => setClearHistory(e.target.checked)}
                    style={{
                      position: 'absolute',
                      opacity: 0,
                      height: 0,
                      width: 0,
                    }}
                  />
                  <span
                    style={{
                      display: 'inline-block',
                      width: '20px',
                      height: '20px',
                      border: '2px solid #2196F3',
                      borderRadius: '4px',
                      transition: 'all 0.3s',
                      position: 'relative',
                      background: clearHistory ? '#2196F3' : 'transparent',
                    }}
                  >
                    {clearHistory && (
                      <span
                        style={{
                          position: 'absolute',
                          left: '50%',
                          top: '50%',
                          transform: 'translate(-50%, -50%)',
                          width: '12px',
                          height: '12px',
                          background: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='white'%3E%3Cpath d='M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z'/%3E%3C/svg%3E")`,
                        }}
                      />
                    )}
                  </span>

                  {/* تأثيرات hover */}
                  <style>{`
                     label:hover span:first-of-type {
                       border-color: #1565C0;
                       transform: scale(1.05);
                       box-shadow: 0 0 8px rgba(33, 150, 243, 0.3);
                     }
                   `}</style>
                </label>

                <label
                  htmlFor="clear-history"
                  style={{
                    cursor: 'pointer',
                    userSelect: 'none',
                    fontSize: '16px',
                    color: '#333',
                    transition: 'color 0.3s',
                  }}
                >
                  Clear previous comments for this sales
                </label>
              </Box>

              {/* <div className='d-flex justify-content-center w-100 my-3 ' >
             <div 
               onClick={senddleedtosalesaction} 
               className='mx-2 button-18' 
               style={{width: '50%', position: 'relative'}}
             >
               {loading ===false? (
                 <CircularProgress size={24} style={{color: 'white'}} />
               ) : (
                 <>
                   <SendIcon/> Send
                 </>
               )}
             </div>    
               </div> */}

              <div className="d-flex justify-content-end w-100 flex-wrap gap-3 mb-3">
                <label className={`radio-box ${selectedOption === 'option1' ? 'active' : ''}`}>
                  <input
                    type="radio"
                    name="customRadio"
                    value="option1"
                    checked={selectedOption === 'option1'}
                    onChange={(e) => setSelectedOption(e.target.value)}
                  />
                  <span>Same Stage</span>
                </label>

                <label className={`radio-box ${selectedOption === 'option2' ? 'active' : ''}`}>
                  <input
                    type="radio"
                    name="customRadio"
                    value="option2"
                    checked={selectedOption === 'option2'}
                    onChange={(e) => setSelectedOption(e.target.value)}
                    style={{ color: mode === 'dark' ? '#666' : '#666' }}
                  />
                  <span>Change Stage</span>
                </label>
              </div>

              {/* ✅ ثانياً: Autocomplete يظهر تحتهم عند اختيار option2 */}

              {selectedOption === 'option2' && (
                <div className="d-flex justify-content-end w-100 mb-3">
                  <div style={{ width: '290px' }}>
                    <Autocomplete
                      key={resStagesData.length}
                      options={
                        Array.isArray(localStages)
                          ? localStages
                              // 🧠 أولاً: شيل أي stage اسمها "Fresh"
                              .filter((item) => item.name?.toLowerCase() !== 'fresh')
                              // 🪄 ثانيًا: لو اسمها "No Stage" غيّر الاسم لـ "Fresh"
                              .map((item) => ({
                                label:
                                  item.name?.toLowerCase() === 'no stage'
                                    ? 'Fresh'
                                    : item.name || '',
                                value: item._id || '',
                              }))
                          : []
                      }
                      loading={resStagesData.length === 0}
                      getOptionLabel={(option) => option?.label || ''}
                      value={
                        selectedStage
                          ? resStagesData
                              .map((item) => ({
                                label:
                                  item.name?.toLowerCase() === 'no stage' ? 'Fresh' : item.name,
                                value: item._id,
                              }))
                              .find((opt) => opt.value === selectedStage.value) || null
                          : null
                      }
                      onChange={stagechange}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Select Stage"
                          variant="outlined"
                          placeholder={
                            resStagesData.length === 0 ? 'Loading stages...' : 'Choose Stage'
                          }
                          sx={{
                            '& .MuiInputBase-root': {
                              backgroundColor: mode === 'dark' ? '#252525' : '#f5f5f5',
                              borderRadius: '12px',
                              padding: '6px 10px',
                              color: mode === 'dark' ? '#90caf9' : '#102dff',
                              boxShadow: mode === 'dark' ? '0 0 4px #1e1e1e' : '0 0 4px #ccc',
                            },
                            '& .MuiOutlinedInput-notchedOutline': {
                              borderColor: '#0F7687',
                            },
                            '&:hover .MuiOutlinedInput-notchedOutline': {
                              borderColor: '#0F7687',
                            },
                            '& .Mui-focused .MuiOutlinedInput-notchedOutline': {
                              borderColor: '#0F7687',
                            },
                            '& .MuiInputLabel-root': {
                              color: mode === 'dark' ? '#90caf9' : '#102dff',
                            },
                            '& .MuiSvgIcon-root': {
                              color: '#102dff',
                            },
                          }}
                        />
                      )}
                    />
                  </div>
                </div>
              )}
              {/* ✅ ستايل الراديو بوتونز */}
              <style jsx>{`
                .radio-box {
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  border: 2px solid #ccc;
                  border-radius: 10px;
                  padding: 12px 24px;
                  cursor: pointer;
                  transition: all 0.3s ease;
                  min-width: 120px;
                  text-align: center;
                  position: relative;
                  font-weight: 500;
                  background-color: #fff;
                }

                .radio-box input {
                  display: none;
                }

                .radio-box.active {
                  border-color: #102dff;
                  background-color: #102dff;
                  // color: white;
                }

                .radio-box:hover {
                  border-color: #102dff;
                }
              `}</style>

              <hr className="my-4" />

              <div className="d-flex justify-content-center w-100 my-3">
                <div
                  onClick={!sendloading ? senddleedtosalesaction : null}
                  className="mx-2 button-18"
                  style={{
                    background: sendloading ? '#888' : '#102dff',
                    width: '50%',
                    position: 'relative',
                    pointerEvents: sendloading ? 'none' : 'auto',
                    opacity: sendloading ? 0.6 : 1,
                    cursor: sendloading ? 'not-allowed' : 'pointer',
                  }}
                >
                  {sendloading === true ? (
                    <CircularProgress size={24} style={{ color: 'white' }} />
                  ) : (
                    <>
                      <SendIcon /> Send
                    </>
                  )}
                </div>
              </div>
            </Typography>
          </Box>
        </Col>
      </Row>
    </Container>
  );
};
